import { useState, useEffect } from 'react';
import { Flex, Title } from './TremorCompat';
import { Button, Icon } from './TremorCompat';
import Modal from 'rsuite/Modal';
import { MdDelete as IconRubbish } from 'react-icons/md';
import { COLOURS } from '../styles';

export const ShowDeviceDeleteConfirmation = ({ open, device, handleClose }) => {
  const [id, setId] = useState(device.uniqueDeviceId);

  useEffect(() => {
    setId(device.uniqueDeviceId);
  }, [device.uniqueDeviceId]);

  return (
    <Modal open={open} onClose={() => handleClose(null)} backdrop="static">
      <Modal.Header closeButton={true}>
        <Modal.Title>
          <div className="space-y-2">
            <Flex justifyContent="center" alignItems="center" className="space-x-1">
              <Icon icon={IconRubbish} color={COLOURS.default} />
              <Title color={COLOURS.default}>Confirm Remove</Title>
            </Flex>
            <Title color={COLOURS.default}>{device.userName} </Title>
            <Title color={COLOURS.default}>{device.uniqueDeviceId} </Title>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Flex justifyContent="center" alignItems="center" className="space-x-1"></Flex>
      </Modal.Body>
      <Modal.Footer>
        <Flex justifyContent="center" alignItems="center" className="space-x-2">
          <Button color={COLOURS.default} size="sm" onClick={() => handleClose({ id })} disabled={false}>
            Remove
          </Button>
          <Button color={COLOURS.default} size="sm" onClick={() => handleClose(null)} disabled={false}>
            Cancel
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal>
  );
};
